export default __webpack_public_path__ + "static/media/Bengali_agri_m.089b2525.wav";